import { Component,Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmacionesService} from '../../../services/confirmaciones.service';
import { PagosService} from '../../../services/pagos-service.service';
import { CatalogosService } from '../../../services/catalogos.service';


@Component({
    selector: 'control-pagos',
    templateUrl: './control-pagos.component.html'
})

export class ControlPagosComponent implements OnInit {
    //Inputs y variables declaradas
    @Input() idCliente: any;
    @Input() idConfirmacion: any;
    @Input() cliente:Observable<any>;
    @Input() servicios:Observable<any>;
    objetoConfirmacion:Observable<any>;

    resultadolista:any;
    tipoDePagoActivo='ninguno';
    //Declaracion de servicios
    constructor(private confirmacionesService : ConfirmacionesService){}

    // Función de OnInit
    ngOnInit(){
        //Realiza una consulta  ala confirmacion y es obtenida para pasarla a los hijos y no repetir la accion
        this.objetoConfirmacion= this.confirmacionesService.obtenerConfirmacion(this.idConfirmacion).snapshotChanges().take(1).map(confirmacionDB => {
            //Se agrega  la key al objeto de la confirmacion
            let objeto ={
                data:confirmacionDB.payload.data(),
                $key:confirmacionDB.payload.id
            }
            return objeto
        });
    }
    //Almacena en una variable  el objeto que es emitido desde lista de pagos
    objetoPagoProgramado(resultado){
        this.resultadolista = resultado;
        this.tipoDePagoActivo= 'registro';
    }
    //Switch para ver que accion se realizara si progrmaar o registrar pago
    avtivarTipoDePago(tipo){
        this.resultadolista={esEditar:false}
        this.tipoDePagoActivo=tipo
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/control-pagos/control-pagos.component.ts